// extracted by mini-css-extract-plugin
export var readonly = "_hg-1";
export var star = "_hg-0";